










import { Component, Vue } from 'vue-property-decorator';
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css'; // Vuesax styles

Vue.use(Vuesax);
@Component
export default class Loader extends Vue {}
